import { ApiDocumentTypes, ApiFragmentNode } from "../../shared/interfaces";
import { useShowDebugInfo } from "../../hooks/configuration";

export function NodeTitle({
    node,
    includeDocumentType = false,
}: {
    node: ApiFragmentNode;
    includeDocumentType?: boolean;
}) {
    const showDebugInfo = useShowDebugInfo();

    return (
        <>
            {includeDocumentType &&
                (node.documentType === ApiDocumentTypes.Drawing
                    ? "Drawing - "
                    : "Specification - ")}
            {node.title}
            {node.hierarchyId && node.hierarchyId !== "*" && `: ${node.hierarchyId}`}
            {showDebugInfo && node.distance !== undefined && `, (${node.distance.toFixed(3)})`}
        </>
    );
}
